import { useReducer, createContext } from 'react';

import { initialState } from './initial-state';
import { activities } from './reducers/activites';
import { app } from './reducers/app';
import { cacheState } from './reducers/cache-state';
import { config } from './reducers/config';
import { configuration } from './reducers/configuration';
import { fantasy } from './reducers/fantasy';
import { fantasyHistoric } from './reducers/fantasyHistoric';
import { fixtures } from './reducers/fixtures';
import { onceTipo } from './reducers/onceTipo';
import { playerProfile } from './reducers/player-profile';
import { preferences } from './reducers/preferences';
import { theme } from './reducers/theme';
import { user } from './reducers/user';
import { partidos } from './reducers/partidos';
import { favoritos } from './reducers/favoritos';
import { jugadores } from './reducers/jugadores';
import { stories } from './reducers/stories';
import { apuestasDeportivasFeed } from './reducers/apuestas-deportivas-feed';

// create context
const Context = createContext({});

// combine reducer function
const combineReducers =
    (...reducers) =>
    (state, action) => {
        for (let i = 0; i < reducers.length; i++) state = reducers[i](state, action);
        return state;
    };

// context provider
const Provider = ({ children }) => {
    const [state, dispatch] = useReducer(
        combineReducers(
            user,
            app,
            fixtures,
            config,
            fantasy,
            configuration,
            playerProfile,
            preferences,
            activities,
            fantasyHistoric,
            theme,
            cacheState,
            onceTipo,
            partidos,
            favoritos,
            jugadores,
            stories,
            apuestasDeportivasFeed
        ),
        initialState
    );
    const value = { state, dispatch };

    return <Context.Provider value={value}>{children}</Context.Provider>;
};

export { Context, Provider };
